import { useServerRequest } from '../../api'
import { type GetHookResponse } from '../../hooks'
import { gamePrizeInfoKey } from '../../keys'
import { useTantalimQuery } from '../../query'
import {
  HOUR,
  isNotEmpty,
  type GamePrizeInfo,
  type GamePrizeInfoInput,
  type GamePrizeInfoSuccess,
} from '@terros/common'
import { useCallback } from 'react'

export function usePrizeInfo(url: string): GetHookResponse<GamePrizeInfo> {
  return useTantalimQuery<GamePrizeInfoInput, GamePrizeInfoSuccess, GamePrizeInfo>({
    url: '/game/prize/info',
    queryKey: gamePrizeInfoKey(url),
    input: { url },
    convertResponse: (data) => data.prizeInfo,
    options: {
      enabled: isNotEmpty(url),
      gcTime: HOUR,
      staleTime: HOUR,
    },
  })
}

export const useGetPrizeInfo = (): ((url: string) => Promise<GamePrizeInfo>) => {
  const serverRequest = useServerRequest<GamePrizeInfoInput, GamePrizeInfoSuccess>('/game/prize/info')
  return useCallback(
    async (url: string) => {
      const response = await serverRequest({ url })
      return response.prizeInfo
    },
    [serverRequest]
  )
}
